<script>
import { getInboxClassByType } from 'dashboard/helper/inbox';

export default {
  props: {
    inbox: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    computedInboxClass() {
      const { phone_number: phoneNumber, channel_type: type, name } = this.inbox;
      const classByType = getInboxClassByType(type, phoneNumber, name);
      return classByType;
    },
    computedInboxAvatar() {
      const { ub_avatar_url } = this.inbox;
      return ub_avatar_url;
    },
  },
};
</script>

<template>
  <div
    class="inbox--name inline-flex items-center py-0.5 px-0 leading-3 whitespace-nowrap bg-none text-n-slate-11 text-xs my-0 mx-2.5"
  >
    <img v-if="computedInboxAvatar" :src="computedInboxAvatar" class="w-[12px] h-[12px] mr-0.5 rtl:ml-0.5 rtl:mr-0" />
    <fluent-icon
      v-else
      class="mr-0.5 rtl:ml-0.5 rtl:mr-0"
      :icon="computedInboxClass"
      size="12"
    />
    {{ inbox.name }}
  </div>
</template>
